export enum EmployeeRoleEnum {
    CA_ICS_HBE="CA_ICS_HBE",
    CA_ICS_VT="CA_ICS_VT",
    CM_EP= "CM_EP",
    AC= "AC",
    DISCO= "DISCO"
}

